import _classCallCheck from "/home/maroua/Workspace/dotpedia-website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/maroua/Workspace/dotpedia-website/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/maroua/Workspace/dotpedia-website/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/maroua/Workspace/dotpedia-website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/maroua/Workspace/dotpedia-website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { EventEmitter as NativeEventEmitter } from 'events';
export var EventEmitter = /*#__PURE__*/function (_NativeEventEmitter) {
  _inherits(EventEmitter, _NativeEventEmitter);

  var _super = _createSuper(EventEmitter);

  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    return _super.apply(this, arguments);
  }

  _createClass(EventEmitter, [{
    key: "emitAsync",
    value: function emitAsync(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return this.listeners(event).reduce(function (promise, listener) {
        return promise.then(function () {
          return Promise.resolve(listener.apply(void 0, args));
        });
      }, Promise.resolve(null)).catch(function (error) {
        throw error;
      });
    }
  }, {
    key: "onceAsync",
    value: function onceAsync(event) {
      var _this = this;

      return new Promise(function (resolve) {
        return _this.once(event, resolve);
      });
    }
  }]);

  return EventEmitter;
}(NativeEventEmitter);